<template>
  <div class="invite-motion-banner">
    <p class="invite-motion-banner__title typo-heading-xxl-bold">
      친구와 함께<br/>혜택을 나눠보세요
    </p>
    <div class="invite-motion-banner__motion">
      <img :src="motionImage" alt="모션 이미지" class="invite-motion-banner__motion-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteMotionBanner',
  data() {
    return {
      motionImage: require('@/assets/home/top_motion.apng'),
    }
  },
}
</script>

<style scoped>
.invite-motion-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 340px;
  align-self: stretch;
  background: #D8D9F0;
}

.invite-motion-banner__title {
  color: #323470;
  text-align: center;
  margin: 36px 0 0 0;
}

.invite-motion-banner__motion {
  margin-top: 0;
}

.invite-motion-banner__motion-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteMotionBanner.vue